import React from "react"
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import ReactTooltip from 'react-tooltip'

import ErrorModal from "./modals/ErrorModal"
import LoadingModal from "./modals/LoadingModal"
import {initializeApp} from "../state/app/actions"
import HomePage from "./HomePage"
import {fetchUserProfile} from "../state/userProfile/actions"
import {handlePayCargoPopupDone} from "../state/payment/actions"
import {HashRouter, Route, Switch} from 'react-router-dom'
import DndProcess from "./DndProcess"
import DigitalHomePage from "./DigitalHomePage"
import DigitalDndProcess from "./DigitalDndProcess"
import "./styles/digital-design-override.scss"

export class AppComponent extends React.Component {

  componentDidMount() {
    this.props.actions.fetchUserProfile()
    this.registerPayCargoEventHandlers()
  }

  componentDidUpdate(prevProps) {
    const userProfile = this.props.userProfile
    if (!prevProps.userProfile && userProfile) {
      this.initializeMatomo(userProfile)
      if (this.props.isMocEnabled) {
        document.body.classList.add(this.props.userProfile.isForCosco ? 'cosco-digital-design-enabled' : 'oocl-digital-design-enabled')
      }
    }
  }

  getCookieValue(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
    return match ? decodeURIComponent(match[2]) : null
  }

  initializeMatomo(userProfile) {
    const ENV = userProfile.env

    if (ENV === 'DEV' || userProfile.forCosco) {
      return
    }

    const consentData = this.getCookieValue('oocl_cookie_consent')
    if (!consentData || !consentData.includes('statistical')) {
      console.log('CFTA tracking skipped - no statistical consent')
      return
    }

    const cookieDomain = ENV === 'PRD' ? 'rtr.home.oocl.com' : 'rtr-int.home-np.oocl.com'
    const _paq = (window._paq = window._paq || [])

    _paq.push(['setCookieDomain', cookieDomain])

    if (ENV !== 'local') {
      _paq.push(['setExcludedQueryParams', ['token', 'access_token']])
    }
    _paq.push(['setUserId', userProfile.encryptedEmail])
    _paq.push(['trackPageView'])
    _paq.push(['enableLinkTracking'])

    const cftaUrl = ENV === 'PRD' ? 'https://cfta.oocl.com/' : 'https://cfta-np.oocl.com/'
    const siteId = ENV === 'PRD' ? '17' : '22'

    _paq.push(['setTrackerUrl', cftaUrl + 'matomo.php'])
    _paq.push(['setSiteId', siteId])

    const d = document
    const g = d.createElement('script')
    const s = d.getElementsByTagName('script')[0]
    g.type = 'text/javascript'
    g.async = true
    g.src = cftaUrl + 'matomo.js'
    s.parentNode.insertBefore(g, s)
  }

  getHomePage() {
    return this.props.isMocEnabled ? <DigitalHomePage/> : <HomePage/>
  }

  getDndProcessPage() {
    return this.props.isMocEnabled ? <DigitalDndProcess/>: <DndProcess/>
  }

  getLoadingImage() {
    return this.props.isMocEnabled ?
        (<img src="/images/loading-moc.gif" alt="Loading..." style={{width: 80}}/>) :
        (<img src="/images/loading2.gif" alt="Loading..." style={{width: 50}}/>)
  }

  render() {
    if (!this.props.userProfile) {
      return (
          <div
              style={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
            {this.getLoadingImage()}
          </div>
      )
    }

    return (
        <div>
          <LoadingModal/>
          <ErrorModal/>

          <ReactTooltip id="n2c3-tooltip" class="tooltip icon-tooltip" effect="solid" place="left"
                        offset={{bottom: 5, right: 0}}/>
          <HashRouter>
            <Switch>
              <Route exact path="/">
                {this.getHomePage()}
              </Route>
              <Route path="/process">
                {this.getDndProcessPage()}
              </Route>
            </Switch>
          </HashRouter>
        </div>
    )
  }

  registerPayCargoEventHandlers() {
    const paycargoCheckout = document.querySelector('paycargo-checkout')
    if (!paycargoCheckout) {
      console.log('Paycargo checkout not found')
      return
    }

    // event to signal when payment is completed
    paycargoCheckout.addEventListener('paymentResponse', event => {
      this.props.actions.handlePayCargoPopupDone(event)
    })

    // event to signal when modal is closed
    paycargoCheckout.addEventListener('close', event => {
      this.props.actions.handlePayCargoPopupDone(event)
    })
    console.log('succesfully registered PC callbacks')
  }
}

function mapStateToProps(state) {
  return {
    redirectUrl: state.app.redirectUrl,
    userProfile: state.userProfile,
    isMocEnabled: state.app.isMocEnabled
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      initializeApp,
      fetchUserProfile,
      handlePayCargoPopupDone
    }, dispatch), dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppComponent)